/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'label-stocks': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<g _fill="none" fill-rule="evenodd"><rect pid="0" _fill="#797D7F" width="18" height="18" rx="2"/><g _fill="#FFF" fill-rule="nonzero"><path pid="1" d="M3.167 3v1.167h1.166V3zM11.333 3v1.167H12.5V3zM14.925 4.167L12.42 6.325l-2.28-1.966L7.098 6.98 4.82 5.014 2 7.444l1.075.926 1.743-1.503L7.1 8.833l3.041-2.621 2.281 1.966L16 5.093zM3.167 8.833V10h1.166V8.833zM11.333 8.833V10H12.5V8.833zM3.167 11.167v1.166h1.166v-1.166zM11.333 11.167v1.166H12.5v-1.166zM2 13.5v1.167h14V13.5z"/></g></g>'
  }
})
